import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { apiURL } from "../config";
import { useSelector } from "react-redux";

function TopBar({ responsive }) {
  const windowState = useSelector((state) => state.window);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const handleLogOut = async function (event) {
    event.preventDefault();
    const response = await fetch(`${apiURL}/api/logout`, {
      method: "GET",
      credentials: "include",
    });

    const data = await response.json();
    //console.log(data)
    if (data.message === "SUCCESS") {
      window.location.reload();
      //navigate('/')
    }
  };
  let display = "flex";
  if (responsive) {
    display = windowState === "large" ? "none" : "flex";
  }
  return (
    <nav
      className="fixed top-0 z-100 flex w-full items-center justify-between px-4 py-2 bg-gray-100"
      style={{ display, zIndex: "100" }}
    >
      <div className="flex items-center hover:scale-110 transition">
        {responsive ? (
          <span className="text-lg font-semibold cursor-pointer">History</span>
        ) : (
          <span
            className="text-lg font-semibold cursor-pointer"
            onClick={() => navigate("/")}
          >
            Home
          </span>
        )}
      </div>

      <div className="flex items-center ">
        {user.username === "" ? (
          <>
            <Link
              to="/register"
              className="px-3 py-1 text-gray-600 hover:scale-110 transition"
            >
              Register
            </Link>
            <Link
              to="/login"
              className="px-3 py-1 text-gray-600 hover:scale-110 transition"
            >
              Log in
            </Link>
          </>
        ) : (
          <>
            <span className="px-3 py-1 text-gray-500">{user.username}</span>
            <span
              className="px-3 py-1 text-gray-600 hover:scale-110 transition cursor-pointer"
              onClick={(e) => handleLogOut(e)}
            >
              Log out
            </span>
          </>
        )}
      </div>
    </nav>
  );
}

export default TopBar;
